// Types
import { BCIndividualRef } from "services/pace/dashboard.service";
import { TPerson } from "../BehaviouralComparison.types";

export const convertIndividualsRef = (data: BCIndividualRef[], selectedPeople: TPerson[]): TPerson[] => {
    const selectedPeopleIds = (selectedPeople || []).map((p) => p.id);

    return data.map((el) => ({
        id: el.id,
        name: el.name,
        checked: selectedPeopleIds.includes(el.id),
        teams: [],
    }));
};
